export default __webpack_public_path__ + "static/bunker-web-3-mobile-0e7d07f7a1ca3b5a86bf8a160ac1f9b4.jpg";